/* Phone World 96 — Pro layer: copy codes, welcome popup, offer button, grid motion */
(function () {
  'use strict';
  var KEY = 'pw96_welcome_v1';
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }

  /* ---- Copy-to-clipboard for discount codes ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pw-copy]');
    if (!btn) return;
    var code = btn.getAttribute('data-pw-copy');
    var done = function () {
      var old = btn.textContent;
      btn.textContent = 'Copied!';
      setTimeout(function () { btn.textContent = old; }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
    else {
      var t = document.createElement('textarea'); t.value = code; document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); } catch (err) {} document.body.removeChild(t); done();
    }
  });

  /* ---- Welcome popup ---- */
  function initPopup() {
    var pop = document.getElementById('pw-pop');
    var fab = document.getElementById('pw-fab');
    if (!pop) return;
    var lastFocus;

    function open() {
      lastFocus = document.activeElement;
      pop.classList.add('is-open');
      pop.setAttribute('aria-hidden', 'false');
      var f = pop.querySelector('input[type=email], .pw-pop__close');
      if (f) setTimeout(function () { f.focus(); }, 60);
      if (fab) fab.classList.remove('is-on');
    }
    function close() {
      pop.classList.remove('is-open');
      pop.setAttribute('aria-hidden', 'true');
      if (store(KEY) !== 'subscribed') store(KEY, 'dismissed');
      if (fab && store(KEY) !== 'subscribed') fab.classList.add('is-on');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    pop.addEventListener('click', function (e) {
      if (e.target === pop || e.target.closest('[data-pw-close]')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('is-open')) close(); });
    if (fab) fab.addEventListener('click', open);
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-pw-open-offer]')) { e.preventDefault(); open(); }
    });

    var form = pop.querySelector('form');
    if (form) form.addEventListener('submit', function () { store(KEY, 'subscribed'); });

    var posted = /[?&]customer_posted=true/.test(location.search);
    var popPosted = posted && (location.hash === '#pw-pop-form' || pop.querySelector('.pw-code'));
    if (popPosted) { store(KEY, 'subscribed'); open(); return; }
    if (posted && pop.querySelector('.pw-pop__err')) { open(); return; }

    var state = store(KEY);
    if (state === 'subscribed') return;
    if (state === 'dismissed') {
      if (fab) setTimeout(function () { fab.classList.add('is-on'); }, 1200);
      return;
    }
    var delay = Number(pop.getAttribute('data-delay') || 7) * 1000;
    if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) { if (fab) fab.classList.add('is-on'); return; } // phones: no auto popup (Google interstitial guidance); 10% button still opens it
    var timer = setTimeout(open, delay);
    // Exit-intent on desktop opens it sooner
    document.addEventListener('mouseout', function onOut(e) {
      if (!e.relatedTarget && e.clientY < 8) { clearTimeout(timer); document.removeEventListener('mouseout', onOut); if (!pop.classList.contains('is-open')) open(); }
    });
  }

  /* ---- Staggered entrance for product grid cards ---- */
  function initGrid(scope) {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var items = (scope || document).querySelectorAll('.product-grid__item:not(.pw-in):not(.pw-in-wait)');
    if (!items.length) return;
    var io = new IntersectionObserver(function (entries) {
      var i = 0;
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target; io.unobserve(el);
        setTimeout(function () { el.classList.add('pw-in'); el.classList.remove('pw-in-wait'); }, (i++ % 8) * 70);
      });
    }, { rootMargin: '0px 0px -5% 0px', threshold: 0.05 });
    items.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.95) { el.classList.add('pw-in'); return; }
      el.classList.add('pw-in-wait'); io.observe(el);
    });
  }

  function boot() { initPopup(); initGrid(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Filters/sorting re-render the grid
  var pending = false;
  new MutationObserver(function () {
    if (pending) return; pending = true;
    setTimeout(function () { pending = false; initGrid(); }, 250);
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
